import { H1, P } from '@manulife/mux';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useAdobeAnalyticsPage from '../../CustomHooks/useAdobeAnalyticsPage';
import Layout, { LAYOUT_VARIANT } from '../Layout/Layout';

const ErrorPage = ({ error, logger }) => {
    const dispatch = useDispatch();
    const { sendAdobeAnalyticsError } = useAdobeAnalyticsPage('manage-profile:error', 'Member Profile - Error');

    useEffect(() => {
        if (error && error.hasError) {
            sendAdobeAnalyticsError(error.code, 'criticalError', error.message);
        }
    }, [error, dispatch, sendAdobeAnalyticsError]);

    return (
        <Layout
            id="errorPage"
            logger={logger}
            layoutVariant={LAYOUT_VARIANT.BANNERLESS}
            pageTitle="Something went wrong / Quelque chose s'est mal passé"
        >
            <H1>Oops! Something Went Wrong! / Oops! Quelque chose s'est mal passé!</H1>
            <P>Sorry! Something went wrong. Try again later.</P>
            <P>Désolé! Un problème est survenu. Essayez plus tard.</P>

            {error && (
                <P>
                    <small>
                        <strong>Error Code:</strong> {error.code}
                    </small>
                </P>
            )}
        </Layout>
    );
};

export default ErrorPage;
